/**
 * ลิงก์ไปหน้า "คู่มือการใช้งาน" บนเว็บสาธารณะ (bangbow-website-new-dev: /web-factory-manual)
 * พร้อมแนบ token ของบัญชีโรงงานที่ล็อกอินอยู่ ผ่าน URL hash (`#t=...`)
 *
 * ไม่ใช่การ login เข้าเว็บนั้น (ไม่สลับ/ทับบัญชีสมาชิกที่อาจล็อกอินค้างอยู่บนเว็บ) — แค่ให้ฝั่งเว็บ
 * รู้ว่าเป็นบัญชีโรงงาน (user_role.ref_type = 'factory') เพื่อปลดล็อกสื่อ access_level='factory'
 * โดยอัตโนมัติ ดูฝั่งรับที่ bangbow-website-new-dev `lib/manual-factory-sso.ts`
 *
 * เข้ารหัสแบบเดียวกับ bangbow-website-new-dev `lib/portal-sso.ts` (XOR ด้วย key ที่สองเว็บรู้ร่วมกัน
 * + base64url) — hash ไม่ถูกส่งขึ้น server/log/referrer ตามแบบเดียวกับที่ใช้เชื่อม Member Portal
 * แก้ฝั่งหนึ่งต้องแก้อีกฝั่งให้ตรงกัน (key คนละชื่อ env กันเพราะคนละ build tool: ที่นี่ CRA ใช้
 * REACT_APP_*, ฝั่งเว็บใช้ NEXT_PUBLIC_* — ต้องตั้งให้เป็นค่าเดียวกันถ้า override จาก default)
 */
import { store } from "store";

const XFER_KEY = process.env.REACT_APP_SSO_XFER_KEY || "bangbow-sso-xfer-2026";
const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://www.bangbow.com";

function encodeSsoToken(token: string): string {
  const data = new TextEncoder().encode(token);
  const key = new TextEncoder().encode(XFER_KEY);
  let bin = "";
  for (let i = 0; i < data.length; i++) {
    bin += String.fromCharCode(data[i] ^ key[i % key.length]);
  }
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** ลิงก์หน้าคู่มือ — แนบ token โรงงานถ้าล็อกอินอยู่ (ไม่ล็อกอิน = ลิงก์เปล่า เห็นได้แค่หัวข้อ public) */
export function manualHref(): string {
  const token = store.getState().auth.accessToken;
  if (!token) return `${WEBSITE_URL}/web-factory-manual`;
  return `${WEBSITE_URL}/web-factory-manual#t=${encodeSsoToken(token)}`;
}
